import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import LinkButton from './custom/LinkButton';
import { mdiEmail,mdiLinkedin,mdiGithubCircle } from '@mdi/js';


const useStyles = makeStyles(theme => ({
    container:{
      width: '100%',
      padding:'10px',
      display:'flex',
      justifyContent:"space-around",
      alignItems:'center',
      //position:'fixed',
      bottom:'0',
      left:'0',
      right:'0'
    }
  }));


export default function Footer(props) {
  //const [isOpen,setOpen] = useState(false)
  //const [photoIndex,setPhotoIndex] = React.useState(0)
  //const [showMorePhotos,setShowMorePhotos] = React.useState(false)
  const classes = useStyles();


    return (
      <div className={classes.container}>
        <span>
         © Amit Turner, 2020
          </span>
        <br />
        <div>
        <LinkButton text="" icon={mdiEmail} link="mailto:amitur91@gmail.com"/>
          
        <LinkButton text="" icon={mdiLinkedin} link="https://www.linkedin.com/in/amit-turner/"/>
          
          <LinkButton text="" icon={mdiGithubCircle} link="https://github.com/AmitTurner"/>
          </div>
           
      </div>
    );
  }